export default __webpack_public_path__ + "static/media/safe-sneakers.01a63076.svg";